module.exports = "<app-guard>\n  <div class=\"action-button\">\n    <div class=\"action-button-container-step ripple shadow-2x animated bounceInRight\">\n      <span class=\"text-center\">\n        {{ data.step }}º\n      </span>\n    </div>\n    <div class=\"action-button-container ripple shadow-2x animated bounceInRight\" (click)=\"save()\">\n      <i class=\"fa fa-floppy-o\"></i>\n    </div>\n  </div>\n</app-guard>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/ui/action-button/action-button.component.html
// module id = 1101
// module chunks = 0